import { Context, IActions, ISaveGrantAmendmentPayload, ISaveGrantAmendmentDetailPayload } from './actions.types'
import { RootState } from '@/store/types'
import { IGrantAmendmentData, Notification, INotification, Grant, IGrant } from '@/entities'
import { ActionTree } from 'vuex';


export const actions: IActions = {
    createAmendment(context: Context, payload: any) {
        return this.$services.grantAmendment.createGrantAmendment(payload)
            .then((data: any) => {
                //context.commit('setGrantAmendment', { grantAmendment: data });
                return data;
            });
    },

    getAmendmentById(context: Context, id: number) {
        return this.$services.grantAmendment.getGrantAmendment(id)
            .then((data: any) => {
                context.commit('setGrantAmendment', data.Record);
                return data.Record;
            });
    },

    getAmendmentDetailById(context: Context, id: number) {
        return this.$services.grantAmendment.getGrantAmendmentDetails(id)
            .then((data: any) => {
                context.commit('setGrantAmendmentDetail', data.Record);
                return data.Record;
            });
    },

    /** update the grant amendment */
    updateAmendment(context: Context, payload: ISaveGrantAmendmentPayload): any {
        return this.$services.grantAmendment.updateAmendment(payload.id, payload.data)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    // context.commit('setGrant', { grant: data.Record });
                    context.commit('application/setNotification', new Notification({ snack: true, text: data.Message || 'Amendment started', color: 'success' } as INotification), { root: true });
                } else {
                    if (data.ValidationMessages && data.ValidationMessages.length > 0) {
                        context.commit('setValidationMessages', data.ValidationMessages);
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification), { root: true })
                    }
                }
            });
    },

    /** Update GrantAmendmentDetails */
    StartAmendmentDetail(context: Context, id: number): any {
        if (id) {
            return this.$services.grantAmendment.StartAmendmentDetail(id)
                .then((data: any) => {
                    if (data.Result === 'OK') {
                        return data;
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification), { root: true })
                    }
                });
        }
    },

    UpdateAmendmentDetail(context: Context, payload: ISaveGrantAmendmentDetailPayload): any {
        if (payload.id) {
            return this.$services.grantAmendment.UpdateAmendmentDetail(payload.id, payload.data)
                .then((data: any) => {
                    if (data.Result === 'OK') {
                        return data;
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification), { root: true })
                    }
                });
        }
    },

    UpdateAmendmentDetailData(context: Context, payload: ISaveGrantAmendmentDetailPayload): any {
        if (payload.id) {
            return this.$services.grantAmendment.UpdateAmendmentDetailData(payload.id, this.$services.application.transformAppData(payload.data), payload.amendmentType)
                .then((data: any) => {
                    if (data.Result === 'OK') {
                        var data = this.$services.application.transformDBEntity(data.Record, context.getters.rootTemplate, false, context.getters.indicators);
                        context.commit('setGrantAmendmentDetailData', data);
                        return data;
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification), { root: true })
                    }
                });
        }
    },

    /** update grant amendment elastic */

    UpdateAmendmentData(context: Context, payload: ISaveGrantAmendmentPayload): any {
        if (payload.id) {
            return this.$services.grantAmendment.UpdateAmendmentData(payload.id, payload.data)
                .then((data: any) => {
                    if (data.Result === 'OK') {
                        context.commit('application/setNotification', new Notification({ snack: true, text: data.Message || 'Updated successfully.', color: 'success' } as INotification), { root: true });
                        return data;
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification), { root: true })
                    }
                });
        }
    },

    /** upload the document */
    uploadDocument(context: Context, payload: any) {
        return this.$services.document.uploadDocument(payload.file, payload.schema, context.state.grantAmendment.GrantAmendmentId, payload.language)
            .then((resp) => {
                return resp;
            }).catch((e) => {
                context.commit('setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification));
            })
    },

    createCustomIndicator(context: Context, payload: any): void {
        return this.$services.application.createCustomIndicator(payload.data, payload.id)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    context.commit('addIndicator', data.Record);
                } else {
                    let spliter = "</br>",
                        errors = "",
                        messages = data.Message.split(spliter);

                    for (var i = 0; i < messages.length; i++) {
                        var message = messages[i].split("@#");
                        if (message && message[1]) {
                            errors += (i + 1).toString() + ". " + message[1] + spliter;
                        }
                    }
                    context.commit('setNotification', new Notification({ snack: true, isHtml: true, text: errors, color: 'error' } as INotification))
                }

                return data;
            });
    },

    updateCustomIndicator(context: Context, payload: any): void {
        return this.$services.application.updateCustomIndicator(payload.data, payload.id)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    context.commit('updateIndicator', data.Record);
                    return data.Record;
                } else {
                    context.commit('setNotification', new Notification({ snack: true, isHtml: false, text: data.Message, color: 'error' } as INotification))
                }
            });
    }
}